const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = function getSearchPath() {
	const searchPath =
		generalSettings.data.siteMetaData.searchCustomPath &&
		`${generalSettings.data.siteMetaData.searchCustomPath}`
			? `${generalSettings.data.siteMetaData.searchCustomPath}`
			: "/search";
	return {
		public: searchPath,
		private: `${generalSettings.data.siteMetaData.privateRoute}${searchPath}`,
	};
};
